import React, { useState } from 'react';
import { PartyPopper, X } from 'lucide-react';

const GOALS = [
  { key: 'camera', ok: 'camera_ok', label: 'Kamera', sold: 'camera_sold' },
  { key: 'device', ok: 'device_ok', label: 'Cihaz', sold: 'device_sold' },
];

export function TargetCelebration({ a }) {
  const now = new Date();
  const storeKey = (g) => `celebrated_${a.username}_${now.getFullYear()}_${now.getMonth() + 1}_${g}`;
  const pending = a.product_target_rule && a.days_left
    ? GOALS.filter(g => a[g.ok] && !localStorage.getItem(storeKey(g.key)))
    : [];
  const [visible, setVisible] = useState(pending.map(g => g.key));
  const shown = pending.filter(g => visible.includes(g.key));
  if (!shown.length) return null;

  const dismiss = (key) => {
    localStorage.setItem(storeKey(key), '1');
    setVisible(v => v.filter(k => k !== key));
  };

  return (
    <div className="space-y-2 mb-3">
      {shown.map(g => (
        <div key={g.key} className="relative flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-green-600 text-white p-3 pr-10 rounded-lg shadow-md animate-in fade-in slide-in-from-top-2 duration-500" data-testid={`target-celebration-${g.key}`}>
          <PartyPopper className="w-7 h-7 shrink-0" />
          <div>
            <p className="font-bold text-sm">Tebrikler! {g.label} hedefini tamamladın</p>
            <p className="text-xs opacity-90">Bu ay {a[g.sold]} adet {g.label.toLowerCase()} sattın. {a.camera_ok && a.device_ok ? 'İki hedef de tamam, üst barem primine hak kazandın!' : 'Diğer hedefi de tamamla, üst barem primi seni bekliyor.'}</p>
          </div>
          <button onClick={() => dismiss(g.key)} className="absolute top-2 right-2 p-1 rounded hover:bg-white/20" aria-label="Kapat" data-testid={`target-celebration-close-${g.key}`}>
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
